export interface AiBudgetState {
  limitCents: number;
  revision: number;
  currency: 'BRL';
  period: 'total';
  meteringStatus: 'not_connected' | 'ledger_ready';
  providerStatus?: 'not_connected' | 'ready_for_sample';
  usage?: { confirmedMicros: number; reservedMicros: number; pendingMicros: number; availableMicros: number; halted: boolean };
  history: Array<{ revision: number; previousLimitCents: number; limitCents: number; subject: string; createdAt: string }>;
}

export class AiBudgetError extends Error {
  constructor(message: string, public status: number) { super(message); this.name = 'AiBudgetError'; }
}

export async function requestAiBudget(token: string, signal: AbortSignal, update?: { limitCents: number; revision: number }): Promise<AiBudgetState> {
  const response = await fetch('https://keycloak.okton.com.br/platform-api/v1/admin/ai-budget', {
    method: update ? 'PUT' : 'GET', credentials: 'include', signal,
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
    ...(update ? { body: JSON.stringify(update) } : {}),
  });
  const payload = await response.json();
  if (!response.ok) throw new AiBudgetError(payload.message || 'Não foi possível acessar o orçamento.', response.status);
  if (!isBudgetState(payload?.data)) throw new AiBudgetError('Resposta de orçamento inválida. Recarregue para conferir o estado.', 502);
  return payload.data;
}

function isBudgetState(data: any): data is AiBudgetState {
  const integer = (value: any) => Number.isSafeInteger(value) && value >= 0;
  if (!data || !integer(data.limitCents) || data.limitCents > 100000000 || !integer(data.revision)
    || data.currency !== 'BRL' || data.period !== 'total'
    || !['not_connected', 'ledger_ready'].includes(data.meteringStatus)
    || !Array.isArray(data.history)) return false;
  if (!data.history.every((item: any) => item && integer(item.revision)
    && integer(item.previousLimitCents) && integer(item.limitCents)
    && typeof item.subject === 'string' && typeof item.createdAt === 'string'
    && Number.isFinite(Date.parse(item.createdAt)))) return false;
  if (data.providerStatus !== undefined && !['not_connected','ready_for_sample'].includes(data.providerStatus)) return false;
  if (data.usage !== undefined && (!data.usage
    || !['confirmedMicros', 'reservedMicros', 'pendingMicros', 'availableMicros'].every(key => integer(data.usage[key]))
    || typeof data.usage.halted !== 'boolean')) return false;
  return true;
}
